<template>
  <div class="list">
    <b-card>
      <b-row class="m-0">
        <!-- Proposal and client data -->
        <b-col
          lg="5"
          class="text-truncate"
          v-if="
            data.steps.riskAssessment.actived ||
            !data.steps.riskAssessment.actived
          "
        >
          <!-- PASSAR TODO O CONTEÚDO DESSA PARTE PARA UM COMPONENTE -->
          <div>
            <!-- <ProposalDetaisClient></ProposalDetaisClient> -->
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center w-100">
                <div class="">
                  <div v-b-toggle="data.id + 'I'" @click.prevent>
                    <!--<div @click="$bvModal.show(data.id + 'I')">  => Abre o modal com os dados da proposta que era e ideia anterior-->
                    <div class="d-flex align-items-center">
                      <b-card-title class="text-truncate">
                        <span
                          class="text-muted pointer"
                          v-b-tooltip.hover.topright
                          :title="data.cpf"
                          >{{ data.name | uppercase }}
                        </span>
                        <small>
                          <b-badge
                            class="ml-1 mb-1 py-1 bg-primary pointer"
                            style
                            v-if="
                              data.participants && data.participants.length > 0
                            "
                            >+{{ data.participants.length }}</b-badge
                          >
                        </small>
                      </b-card-title>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Modal - Dados da Proposta-->
            <b-modal
              :id="data.id + 'I'"
              centered
              title="Dados da proposta"
              style="padding-top: 0px"
            >
              <b-row
                class="bg-light"
                style="
                  box-shadow: rgba(0, 0, 0, 0.04) 0px 1px 15px,
                    rgba(0, 0, 0, 0.04) 0px 1px 6px;
                  z-index: 999;
                  margin-top: -16px;
                "
              >
                <div class="col-12 py-2">
                  <p class="text-muted lead">
                    <b>{{ data.name }}</b>
                  </p>
                  <em class="text-muted mr-2" style="font-size: smaller"
                    >{{ data.operationModality }} /
                    {{ data.amortizationSystem }} / {{ data.indexer }} -
                    {{ definesLowerValueOfTheOperation(data) | currency }}</em
                  >
                  <br />

                  <small class="text-muted">
                    Status:
                    <em
                      class="text-primary"
                      v-if="
                        !data.steps.engineering.actived ||
                        (data.steps.engineering.actived &&
                          data.steps.riskAssessment.status.trim() !=
                            'Aprovado' &&
                          data.steps.riskAssessment.status.trim() !=
                            'Condicionado')
                      "
                      >{{ data.steps.riskAssessment.note }}
                      {{ data.steps.riskAssessment.dueDate | formatDate }}</em
                    >
                    <em
                      class="text-primary"
                      v-if="
                        (data.steps.riskAssessment.status.trim() !=
                          'Aprovado' &&
                          data.steps.engineering.status.trim() != 'Válido') ||
                        (data.steps.riskAssessment.status.trim() !=
                          'Condicionado' &&
                          data.steps.engineering.status.trim() != 'Válido') ||
                        (!data.steps.forms.actived &&
                          data.steps.engineering.status.trim() == 'Válido')
                      "
                      >{{ data.steps.engineering.note }}
                      {{ data.steps.engineering.dueDate | formatDate }}</em
                    >
                    <em
                      class="text-primary"
                      v-if="
                        (data.steps.riskAssessment.status.trim() ==
                          'Aprovado' &&
                          data.steps.engineering.status.trim() == 'Válido' &&
                          data.steps.forms.situation.trim() != 'Recebidos') ||
                        (data.steps.riskAssessment.status.trim() ==
                          'Condicionado' &&
                          data.steps.engineering.status.trim() == 'Válido' &&
                          data.steps.forms.situation.trim() != 'Recebidos')
                      "
                      >{{ data.steps.forms.note }}
                      {{ data.steps.forms.dueDate | formatDate }}</em
                    >
                    <em
                      class="text-primary"
                      v-if="
                        data.steps.forms.situation.trim() == 'Recebidos' &&
                        data.steps.fgts.status.trim() != 'Ressarcida' &&
                        data.fgts
                      "
                      >{{ data.steps.fgts.note }}
                      {{ data.steps.fgts.dueDate | formatDate }}</em
                    >
                    <em
                      class="text-primary"
                      v-if="
                        (!data.fgts &&
                          data.steps.engineering.status.trim() == 'Válido' &&
                          data.steps.forms.situation.trim() == 'Recebidos' &&
                          !data.steps.contract.actived) ||
                        (data.fgts &&
                          data.steps.engineering.status.trim() == 'Válido' &&
                          data.steps.forms.situation.trim() == 'Recebidos' &&
                          data.steps.fgts.status.trim() == 'Ressarcida' &&
                          !data.steps.contract.actived)
                      "
                      >{{ data.steps.dossier.note }}
                      {{ data.steps.dossier.dueDate | formatDate }}</em
                    >
                    <em
                      class="text-primary"
                      v-if="
                        (data.steps.contract.actived &&
                          data.steps.engineering.status.trim() == 'Válido' &&
                          data.steps.forms.situation.trim() == 'Recebidos' &&
                          data.steps.fgts.status.trim() == 'Ressarcida') ||
                        (data.steps.contract.actived &&
                          data.steps.engineering.status.trim() == 'Válido' &&
                          data.steps.forms.situation.trim() == 'Recebidos' &&
                          !data.fgts)
                      "
                      >{{ data.steps.contract.note }}
                      {{ data.steps.contract.dueDate | formatDate }}</em
                    >
                  </small>
                  <small
                    class="d-flex align-items-center collapsed float-right text-muted"
                  >
                    <span
                      aria-controls="collapseSuma"
                      v-if="!showCollapseSuma"
                      @click="showCollapseSuma = !showCollapseSuma"
                    >
                      Ver detalhes <i class="fa fa-chevron-down ml-2"></i>
                    </span>
                    <span
                      aria-controls="collapseSuma"
                      v-if="showCollapseSuma"
                      @click="showCollapseSuma = !showCollapseSuma"
                    >
                      Ver detalhes <i class="fa fa-chevron-up ml-2"></i>
                    </span>
                  </small>
                </div>
              </b-row>
              <b-row>
                <b-col>
                  <b-collapse
                    class="py-3"
                    id="collapseSuma"
                    v-model="showCollapseSuma"
                  >
                    <b-row>
                      <b-col>
                        <h6>
                          <small class="text-muted"
                            >Valor de Financiamento Pretendido</small
                          >
                          <br />{{ data.intendedFinancingValue | currency }}
                          <small class="exp" style="font-size: small"
                            ><!--{{ listToshow == '' ? proposals.length : listToshow.length }}--></small
                          >
                        </h6>
                      </b-col>

                      <b-col>
                        <h6>
                          <small class="text-muted"
                            >Valor de Financiamento Aprovado</small
                          >
                          <br />{{ data.approvedFinancingAmount | currency }}
                          <small class="exp" style="font-size: small"
                            ><!--{{ listToshow == '' ? proposals.length : listToshow.length }}--></small
                          >
                        </h6>
                      </b-col>

                      <h6>
                        <!--<small class="text-muted">Ticket Médio:</small> <br> {{(soma)/(listToshow == '' ? proposals.length : listToshow.length) | currency}}-->
                      </h6>
                    </b-row>

                    <b-row>
                      <b-col>
                        <h6>
                          <small class="text-muted"
                            >Valor de Compra e venda</small
                          >
                          <br />{{ data.propertyValue | currency }}
                          <small class="exp" style="font-size: small"
                            ><!--{{ listToshow == '' ? proposals.length : listToshow.length }}--></small
                          >
                        </h6>
                      </b-col>

                      <b-col>
                        <h6>
                          <small class="text-muted"
                            >Valor de avaliação (engenharia)</small
                          >
                          <br />{{ data.engineeringEvaluation | currency }}
                          <small class="exp" style="font-size: small"
                            ><!--{{ listToshow == '' ? proposals.length : listToshow.length }}--></small
                          >
                        </h6>
                      </b-col>

                      <h6>
                        <!--<small class="text-muted">Ticket Médio:</small> <br> {{(soma)/(listToshow == '' ? proposals.length : listToshow.length) | currency}}-->
                      </h6>
                    </b-row>

                    <b-row>
                      <b-col>
                        <h6>
                          <small class="text-muted"
                            >Valor de Compra e venda</small
                          >
                          <br />{{ data.propertyValue | currency }}
                          <small class="exp" style="font-size: small"
                            ><!--{{ listToshow == '' ? proposals.length : listToshow.length }}--></small
                          >
                        </h6>
                      </b-col>

                      <b-col>
                        <h6>
                          <small class="text-muted"
                            >Valor de avaliação (engenharia)</small
                          >
                          <br />{{ data.engineeringEvaluation | currency }}
                          <small class="exp" style="font-size: small"
                            ><!--{{ listToshow == '' ? proposals.length : listToshow.length }}--></small
                          >
                        </h6>
                      </b-col>

                      <h6>
                        <!--<small class="text-muted">Ticket Médio:</small> <br> {{(soma)/(listToshow == '' ? proposals.length : listToshow.length) | currency}}-->
                      </h6>
                    </b-row>
                  </b-collapse>
                </b-col>
              </b-row>
              <b-row>
                <div class="col-md-12 mt-3">
                  <ul class="timeline">
                    <li class="text-left">
                      <!-- mb-5-->
                      <b-spinner
                        class="positionAlign"
                        type="grow"
                        :variant="
                          data.steps.riskAssessment.status == 'Aprovado' ||
                          data.steps.riskAssessment.status == 'Condicionado'
                            ? 'info'
                            : 'warning'
                        "
                        small
                        label="Loading..."
                        v-if="
                          data.steps.riskAssessment.actived &&
                          data.steps.riskAssessment.status != 'Aprovado' &&
                          data.steps.riskAssessment.actived &&
                          data.steps.riskAssessment.status != 'Condicionado' &&
                          data.steps.riskAssessment.actived &&
                          data.steps.riskAssessment.status != 'Reprovada'
                        "
                      ></b-spinner>
                      <!--:class="data.steps.riskAssessment.status == 'Reprovada' ? 'bg-danger' : 
                        data.steps.riskAssessment.status == 'Aprovado' || data.steps.riskAssessment.status == 'Condicionado' ? 'bg-primary' : 'bg-warning'"-->
                      <span
                        class="stepDone"
                        :style="
                          data.steps.riskAssessment.status == 'Aprovado' ||
                          data.steps.riskAssessment.status == 'Condicionado'
                            ? 'background: #22c0e8; border: 3px solid white;'
                            : data.steps.riskAssessment.status == 'Reprovada'
                            ? 'background: red; border: 3px solid white;'
                            : data.steps.riskAssessment.status == ''
                            ? ''
                            : 'background: orange; border: 3px solid white;'
                        "
                      >
                      </span>
                      <!--:class="data.steps.riskAssessment.status == 'Aprovado' || data.steps.riskAssessment.status == 'bg-danger' ? '' : 'stepDone'"-->
                      <span class="text-primary">Avaliação de risco</span>
                      <!--<span class="text-primary float-right">{{ data.steps.riskAssessment.dueDate | formatDate }}</span>-->
                      <!--<hr>-->
                      <div>
                        <b-row>
                          <b-col>
                            <span
                              v-if="
                                data.steps.riskAssessment.situation !=
                                'Analisado'
                              "
                              class="text-secondary"
                              >{{ data.steps.riskAssessment.situation }}</span
                            >
                            <span v-else class="text-secondary">{{
                              data.steps.riskAssessment.status
                            }}</span>
                            <!--<span class="text-secondary float-right">{{ data.steps.riskAssessment.status }}</span>-->
                          </b-col>
                        </b-row>
                      </div>
                    </li>
                    <li class="text-left">
                      <!-- mb-5-->
                      <b-spinner
                        class="positionAlign"
                        type="grow"
                        :variant="
                          data.steps.engineering.situation != 'Laudo' ||
                          data.steps.engineering.status == 'Válido'
                            ? 'info'
                            : 'warning'
                        "
                        small
                        label="Loading..."
                        v-if="
                          data.steps.engineering.actived &&
                          data.steps.engineering.status != 'Válido' &&
                          data.steps.engineering.status != 'Inválido'
                        "
                      ></b-spinner>
                      <span
                        class="stepDone"
                        :style="
                          data.steps.engineering.status == 'Válido'
                            ? 'background: #22c0e8; border: 3px solid white;'
                            : data.steps.engineering.status == 'Inválido'
                            ? 'background: red; border: 3px solid white;'
                            : data.steps.engineering.status == ''
                            ? ''
                            : 'background: orange; border: 3px solid white;'
                        "
                      >
                      </span>
                      <span class="text-primary"
                        >Engenharia (Avaliação do Imóvel)</span
                      >
                      <span
                        v-if="data.steps.engineering.dueDate"
                        class="text-primary float-right"
                        ><small>{{
                          data.steps.engineering.dueDate | formatDate
                        }}</small></span
                      >
                      <span v-else class="text-primary float-right">-</span>
                      <!--<hr>-->
                      <div>
                        <b-row>
                          <b-col>
                            <span
                              v-if="data.steps.engineering.situation != 'Laudo'"
                              class="text-secondary"
                              >{{ data.steps.engineering.situation }}</span
                            >
                            <span v-else class="text-secondary">{{
                              data.steps.engineering.status
                            }}</span>
                            <!--<span class="text-secondary float-right">{{ data.steps.riskAssessment.status }}</span>-->
                          </b-col>
                        </b-row>
                      </div>
                    </li>
                    <li class="text-left">
                      <!-- mb-5-->
                      <b-spinner
                        class="positionAlign"
                        type="grow"
                        :variant="
                          data.steps.forms.situation != 'Recebidos' &&
                          data.steps.forms.status != 'Inconforme'
                            ? 'info'
                            : 'warning'
                        "
                        small
                        label="Loading..."
                        v-if="
                          (data.steps.forms.actived &&
                            data.steps.forms.situation != 'Recebidos') ||
                          (data.steps.forms.actived &&
                            data.steps.forms.status == 'Inconforme')
                        "
                      ></b-spinner>
                      <span
                        class="stepDone"
                        :style="
                          data.steps.forms.situation == 'Recebidos' &&
                          data.steps.forms.status != 'Inconforme'
                            ? 'background: #22c0e8; border: 3px solid white;'
                            : data.steps.forms.status == ''
                            ? ''
                            : 'background: orange; border: 3px solid white;'
                        "
                      >
                      </span>
                      <span class="text-primary">Formulários</span>
                      <span
                        v-if="data.steps.forms.dueDate"
                        class="text-primary float-right"
                        ><small>{{
                          data.steps.forms.dueDate | formatDate
                        }}</small></span
                      >
                      <span v-else class="text-primary float-right">-</span>
                      <!--<hr>-->
                      <div>
                        <b-row>
                          <b-col>
                            <span
                              v-if="
                                data.steps.forms.situation != 'Recebidos' ||
                                data.steps.forms.status != 'Inconforme'
                              "
                              class="text-secondary"
                              >{{ data.steps.forms.situation }}</span
                            >
                            <span v-else class="text-secondary"
                              >Formulários com pendência(s) a regularizar</span
                            >
                            <!--<span class="text-secondary float-right">{{ data.steps.riskAssessment.status }}</span>-->
                          </b-col>
                        </b-row>
                      </div>
                    </li>
                    <li class="text-left">
                      <!-- mb-5-->
                      <b-spinner
                        class="positionAlign"
                        type="grow"
                        :variant="
                          data.steps.fgts.status != 'Com erro'
                            ? 'info'
                            : 'warning'
                        "
                        small
                        label="Loading..."
                        v-if="
                          data.steps.fgts.actived &&
                          data.steps.fgts.status != 'Ressarcida'
                        "
                      ></b-spinner>
                      <span
                        class="stepDone"
                        :style="
                          !data.fgts
                            ? 'background: #22c0e8; border: 3px solid white;'
                            : data.steps.fgts.status == 'Ressarcida'
                            ? 'background: #22c0e8; border: 3px solid white;'
                            : data.steps.fgts.status ==
                              'Liberação de ressarcimento solicitada'
                            ? ''
                            : data.steps.fgts.status == ''
                            ? ''
                            : 'background: orange; border: 3px solid white;'
                        "
                      >
                      </span>
                      <span class="text-primary">FGTS</span>
                      <span
                        v-if="data.steps.fgts.dueDate"
                        class="text-primary float-right"
                        ><small>{{
                          data.steps.fgts.dueDate | formatDate
                        }}</small></span
                      >
                      <span v-else class="text-primary float-right">-</span>
                      <!--<hr>-->
                      <div>
                        <b-row>
                          <b-col>
                            <span v-if="!data.fgts" class="text-warning"
                              ><i class="fas fa-exclamation-triangle mr-2"></i
                              >Proposta sem utilização de FGTS</span
                            >
                            <span
                              v-else-if="
                                data.steps.fgts.situation == 'Cadastrado'
                              "
                              class="text-secondary"
                              >{{ data.steps.fgts.situation }}</span
                            >
                            <span
                              v-else-if="
                                data.steps.fgts.situation != 'Cadastrado'
                              "
                              class="text-secondary"
                              >{{ data.steps.fgts.status }}</span
                            >
                            <!--<span class="text-secondary float-right">{{ data.steps.riskAssessment.status }}</span>-->
                          </b-col>
                        </b-row>
                      </div>
                    </li>
                    <li class="text-left">
                      <!-- mb-5-->
                      <b-spinner
                        class="positionAlign"
                        type="grow"
                        :variant="
                          data.steps.contract.status != 'Com exigência'
                            ? 'info'
                            : 'warning'
                        "
                        small
                        label="Loading..."
                        v-if="
                          data.steps.contract.actived &&
                          data.steps.contract.status != 'Contratada' &&
                          data.steps.contract.actived &&
                          data.steps.contract.status != 'Evoluída'
                        "
                      ></b-spinner>
                      <span
                        class="stepDone"
                        :style="
                          data.steps.contract.status == 'Contratada' ||
                          data.steps.contract.status == 'Evoluída'
                            ? 'background: #22c0e8; border: 3px solid white;'
                            : data.steps.contract.status == 'Com exigência'
                            ? 'border: 3px solid orange;'
                            : data.steps.contract.status == ''
                            ? ''
                            : ''
                        "
                      >
                      </span>
                      <span class="text-primary">Escritura</span>
                      <span
                        v-if="data.steps.contract.dueDate"
                        class="text-primary float-right"
                        ><small>{{
                          data.steps.contract.dueDate | formatDate
                        }}</small></span
                      >
                      <span v-else class="text-primary float-right">-</span>
                      <div>
                        <b-row>
                          <b-col>
                            <span
                              v-if="
                                data.steps.contract.status != 'Contratada' &&
                                data.steps.contract.status != 'Evoluída'
                              "
                              class="text-secondary"
                              >{{ data.steps.contract.situation }}</span
                            >
                            <span v-else class="text-secondary">{{
                              data.steps.contract.status
                            }}</span>
                          </b-col>
                        </b-row>
                      </div>
                    </li>
                  </ul>
                </div>
              </b-row>

              <template #modal-footer>
                <div class="d-flex justify-content-between w-100">
                  <small
                    >Criado em: <br />
                    {{ getDateCreated }}</small
                  >
                  <small
                    >Atualizado em: <br />
                    {{ getDateUpdated }}</small
                  >
                </div>
              </template>
            </b-modal>
          </div>
        </b-col>
        <!-- Important proposal notes - Hide if it's a new proposal -->
        <b-col
          lg="4"
          class="d-flex align-items-center"
          v-if="data.steps.riskAssessment.actived"
        >
          <div class="d-flex flex-column text-truncate d-inline-block">
            <!-- Details of the requested operation  -->
            <small class="d-flex justify-content-between align-items-center">
              <em
                class="text-info proposal-penultimate"
                v-if="
                  !data.steps.engineering.actived ||
                  (data.steps.engineering.actived &&
                    data.steps.riskAssessment.status.trim() != 'Aprovado' &&
                    data.steps.riskAssessment.status.trim() != 'Condicionado')
                "
                v-b-tooltip.hover.topright
                :title="penultimateTitle(data.steps.riskAssessment)"
                >{{ data.steps.riskAssessment.note }}
                {{ data.steps.riskAssessment.dueDate | formatDate }}</em
              >
              <em
                class="text-info proposal-penultimate"
                v-if="
                  (data.steps.engineering.actived &&
                    data.steps.riskAssessment.situation.trim() != 'Analisado' &&
                    data.steps.engineering.status.trim() != 'Válido') ||
                  (data.steps.engineering.actived &&
                    data.steps.riskAssessment.status.trim() != 'Aprovado' &&
                    data.steps.engineering.status.trim() != 'Válido') ||
                  (data.steps.engineering.actived &&
                    data.steps.riskAssessment.status.trim() != 'Condicionado' &&
                    data.steps.engineering.status.trim() != 'Válido') ||
                  (data.steps.engineering.actived &&
                    !data.steps.forms.actived &&
                    data.steps.engineering.status.trim() == 'Válido')
                "
                v-b-tooltip.hover.topright
                :title="penultimateTitle(data.steps.engineering)"
                >{{ data.steps.engineering.note }}
                {{ data.steps.engineering.dueDate | formatDate }}</em
              >
              <em
                class="text-info proposal-penultimate"
                v-if="
                  (data.steps.forms.actived &&
                    data.steps.riskAssessment.status.trim() == 'Aprovado' &&
                    data.steps.engineering.status.trim() == 'Válido' &&
                    data.steps.forms.situation.trim() != 'Recebidos') ||
                  (data.steps.riskAssessment.status.trim() == 'Condicionado' &&
                    data.steps.engineering.status.trim() == 'Válido' &&
                    data.steps.forms.situation.trim() != 'Recebidos') ||
                  (data.steps.forms.actived &&
                    data.steps.engineering.status.trim() == 'Válido' &&
                    data.steps.forms.situation.trim() == 'Recebidos' &&
                    !data.fgts &&
                    !data.steps.dossier.actived &&
                    !data.steps.contract.actived) ||
                  (data.steps.forms.actived &&
                    data.steps.engineering.status.trim() == 'Válido' &&
                    data.steps.forms.situation.trim() == 'Recebidos' &&
                    data.fgts &&
                    !data.steps.fgts.actived)
                "
                v-b-tooltip.hover.topright
                :title="penultimateTitle(data.steps.forms)"
                >{{ data.steps.forms.note }}
                {{ data.steps.forms.dueDate | formatDate }}</em
              >
              <em
                class="text-info proposal-penultimate"
                v-if="
                  data.fgts &&
                  data.steps.forms.situation.trim() == 'Recebidos' &&
                  data.steps.fgts.status.trim() != 'Ressarcida'
                "
                v-b-tooltip.hover.topright
                :title="penultimateTitle(data.steps.fgts)"
                >{{ data.steps.fgts.note }}
                {{ data.steps.fgts.dueDate | formatDate }}</em
              >
              <em
                class="text-info proposal-penultimate"
                v-if="
                  (!data.fgts &&
                    data.steps.engineering.status.trim() == 'Válido' &&
                    data.steps.forms.situation.trim() == 'Recebidos' &&
                    data.steps.dossier.actived &&
                    !data.steps.contract.actived) ||
                  (data.fgts &&
                    data.steps.engineering.status.trim() == 'Válido' &&
                    data.steps.forms.situation.trim() == 'Recebidos' &&
                    data.steps.fgts.status.trim() == 'Ressarcida' &&
                    !data.steps.contract.actived)
                "
                v-b-tooltip.hover.topright
                :title="penultimateTitle(data.steps.dossier)"
                >{{ data.steps.dossier.note }}
                {{ data.steps.dossier.dueDate | formatDate }}</em
              >
              <em
                class="text-info proposal-penultimate"
                v-if="
                  (data.steps.contract.actived &&
                    data.steps.engineering.status.trim() == 'Válido' &&
                    data.steps.forms.situation.trim() == 'Recebidos' &&
                    data.steps.fgts.status.trim() == 'Ressarcida') ||
                  (data.steps.contract.actived &&
                    data.steps.engineering.status.trim() == 'Válido' &&
                    data.steps.forms.situation.trim() == 'Recebidos' &&
                    !data.fgts)
                "
                v-b-tooltip.hover.topright
                :title="penultimateTitle(data.steps.contract)"
                >{{ data.steps.contract.note }}
                {{ data.steps.contract.dueDate | formatDate }}</em
              >
            </small>

            <!-- <p class="text-truncate" style="margin: 0; font-size: smaller">
              <i
                class="far fa-comments text-warning mr-2"
                v-b-tooltip.hover.top
                title="Observações do Checklist"
                v-if="this.data.comments"
                @click="$bvModal.show(data.id)"
              ></i>

              <small
                class="text-muted"
                v-b-tooltip.hover.top
                :title="data.steps.note"
              >
                <b>{{ data.steps.note }}</b>
              </small>
            </p> -->
            <!-- Modal -->
            <!-- <b-modal
              :id="data.id"
              centered
              hide-footer
              title="Checklist Comentários"
            >
              <p>{{ data.comments }}</p>
            </b-modal> -->
            <!-- End Modal -->
          </div>
        </b-col>

        <!-- New proposal message - Show if it's a new proposal -->
        <b-col
          lg="8"
          class="d-flex flex-column"
          v-if="!data.steps.riskAssessment.actived"
        >
          <div class="d-flex align-items-center btn-block">
            <span class="badge badge-pill badge-success p-2" style="width: 100%"
              >NOVA PROPOSTA</span
            >
          </div>
        </b-col>

        <!-- Proposal progress flow -->
        <b-col
          lg="3"
          class="d-flex flex-column p-0 pr-2"
          v-if="data.steps.riskAssessment.actived"
        >
          <!-- progress of proposal steps -->
          <div class="d-flex justify-content-between align-items-center">
            <!-- Risk Assessment -->
            <b-badge
              v-b-tooltip.hover.bottomright
              :title="
                'Avaliação de risco ' +
                data.steps.riskAssessment.situation +
                ' e ' +
                data.steps.riskAssessment.status
              "
              :variant="data.steps.riskAssessment.badgeColor"
            >
              <i
                class="far fa-file-archive"
                v-if="
                  data.steps.riskAssessment.situation.trim() == 'Em análise' ||
                  data.steps.riskAssessment.status.trim() ==
                    'Com pendência(s)' ||
                  data.steps.riskAssessment.status.trim() == 'Com restrição' ||
                  data.steps.riskAssessment.status.trim() ==
                    'Com restrição e Com pendência(s)'
                "
              ></i>
              <i
                class="fas fa-chart-line"
                v-if="
                  data.steps.riskAssessment.status.trim() == 'Aprovado' ||
                  data.steps.riskAssessment.status.trim() == 'Condicionado' ||
                  data.steps.riskAssessment.status.trim() == 'Reprovada'
                "
              ></i>
            </b-badge>
            <!-- Engineering -->
            <b-badge
              :variant="data.steps.engineering.badgeColor"
              v-b-tooltip.hover.bottomright
              :title="
                'Engenharia ' +
                data.steps.engineering.situation +
                ' e ' +
                data.steps.engineering.status
              "
            >
              <i class="fas fa-home"></i>
            </b-badge>
            <!-- Forms -->
            <b-badge
              :variant="data.steps.forms.badgeColor"
              v-b-tooltip.hover.bottomright
              :title="
                'Formulários ' +
                data.steps.forms.situation +
                ' e ' +
                data.steps.forms.status
              "
            >
              <i class="far fa-file-pdf"></i>
            </b-badge>
            <!-- FGTS -->
            <b-badge
              v-if="data.fgts"
              v-b-tooltip.hover.bottomright
              :title="
                'FGTS ' +
                data.steps.fgts.situation +
                ' e ' +
                data.steps.fgts.status
              "
              :variant="data.steps.fgts.badgeColor"
            >
              <i class="fas fa-hand-holding-usd"></i>
            </b-badge>
            <b-badge
              class="py-1"
              v-if="!data.fgts"
              v-b-tooltip.hover.bottomright
              title="Sem utilização de FGTS"
              variant="success"
            >
              <i class="fas fa-ban"></i>
            </b-badge>
            <!-- Dossier -->

            <b-badge
              v-b-tooltip.hover.bottom
              :title="'Dossiê ' + data.steps.dossier.situation"
              :variant="data.steps.dossier.badgeColor"
              v-if="!data.comments"
            >
              <i
                class="far fa-folder-open"
                v-if="
                  !data.steps.dossier.actived ||
                  (data.steps.dossier.actived &&
                    data.steps.dossier.situation == 'Em montagem')
                "
              ></i>
              <i
                class="fas fa-archive"
                v-if="
                  data.steps.dossier.actived &&
                  data.steps.dossier.situation != 'Em montagem'
                "
              ></i>
            </b-badge>

            <b-badge
              v-else
              v-b-tooltip.hover.bottom
              :title="'Dossiê ' + data.steps.dossier.situation"
              :variant="data.steps.dossier.badgeColor"
              @click="$bvModal.show(data.id)"
            >
              <i class="fas fa-exclamation-triangle"></i>
            </b-badge>
            <!-- Contract -->
            <b-badge
              v-b-tooltip.hover.bottomleft
              :title="
                'Escritura ' +
                data.steps.contract.situation +
                ' ' +
                data.steps.contract.status
              "
              :variant="data.steps.contract.badgeColor"
            >
              <i
                class="far fa-check-circle"
                v-if="
                  !data.steps.contract.actived ||
                  data.steps.contract.situation == 'Em análise de conformidade'
                "
              ></i>
              <i
                class="fas fa-file-contract text-light"
                v-if="data.steps.contract.status == 'Agendada'"
              ></i>
              <i
                class="fas fa-file-signature"
                v-if="data.steps.contract.status == 'Contratada'"
              ></i>
              <i
                class="fas fa-file-invoice-dollar"
                v-if="data.steps.contract.status == 'Evoluída'"
              ></i>
            </b-badge>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <div>
      <b-sidebar
        :id="data.id + 'I'"
        title="Dados da Proposta"
        right
        shadow
        backdrop
        backdrop-variant="dark"
        ><!--id="sidebar-1"-->
        <div class="px-3 py-2">
          <b-row
            class="bg-light"
            style="
              box-shadow: rgba(0, 0, 0, 0.04) 0px 1px 15px,
                rgba(0, 0, 0, 0.04) 0px 1px 6px;
              z-index: 999;
              margin-top: -16px;
            "
          >
            <div class="col-12 py-2">
              <p class="text-muted lead">
                <b>{{ data.name }}</b>
              </p>
              <em class="text-muted mr-2" style="font-size: smaller"
                >{{ data.operationModality }} / {{ data.amortizationSystem }} /
                {{ data.indexer }} -
                {{ definesLowerValueOfTheOperation(data) | currency }}</em
              >
              <br />

              <small class="text-muted">
                Status:
                <em
                  class="text-primary"
                  v-if="
                    !data.steps.engineering.actived ||
                    (data.steps.engineering.actived &&
                      data.steps.riskAssessment.status.trim() != 'Aprovado' &&
                      data.steps.riskAssessment.status.trim() != 'Condicionado')
                  "
                  >{{ data.steps.riskAssessment.note }}
                  {{ data.steps.riskAssessment.dueDate | formatDate }}</em
                >
                <em
                  class="text-primary"
                  v-if="
                    (data.steps.riskAssessment.status.trim() != 'Aprovado' &&
                      data.steps.engineering.status.trim() != 'Válido') ||
                    (data.steps.riskAssessment.status.trim() !=
                      'Condicionado' &&
                      data.steps.engineering.status.trim() != 'Válido') ||
                    (!data.steps.forms.actived &&
                      data.steps.engineering.status.trim() == 'Válido')
                  "
                  >{{ data.steps.engineering.note }}
                  {{ data.steps.engineering.dueDate | formatDate }}</em
                >
                <em
                  class="text-primary"
                  v-if="
                    (data.steps.riskAssessment.status.trim() == 'Aprovado' &&
                      data.steps.engineering.status.trim() == 'Válido' &&
                      data.steps.forms.situation.trim() != 'Recebidos') ||
                    (data.steps.riskAssessment.status.trim() ==
                      'Condicionado' &&
                      data.steps.engineering.status.trim() == 'Válido' &&
                      data.steps.forms.situation.trim() != 'Recebidos')
                  "
                  >{{ data.steps.forms.note }}
                  {{ data.steps.forms.dueDate | formatDate }}</em
                >
                <em
                  class="text-primary"
                  v-if="
                    data.steps.forms.situation.trim() == 'Recebidos' &&
                    data.steps.fgts.status.trim() != 'Ressarcida' &&
                    data.fgts
                  "
                  >{{ data.steps.fgts.note }}
                  {{ data.steps.fgts.dueDate | formatDate }}</em
                >
                <em
                  class="text-primary"
                  v-if="
                    (!data.fgts &&
                      data.steps.engineering.status.trim() == 'Válido' &&
                      data.steps.forms.situation.trim() == 'Recebidos' &&
                      !data.steps.contract.actived) ||
                    (data.fgts &&
                      data.steps.engineering.status.trim() == 'Válido' &&
                      data.steps.forms.situation.trim() == 'Recebidos' &&
                      data.steps.fgts.status.trim() == 'Ressarcida' &&
                      !data.steps.contract.actived)
                  "
                  >{{ data.steps.dossier.note }}
                  {{ data.steps.dossier.dueDate | formatDate }}</em
                >
                <em
                  class="text-primary"
                  v-if="
                    (data.steps.contract.actived &&
                      data.steps.engineering.status.trim() == 'Válido' &&
                      data.steps.forms.situation.trim() == 'Recebidos' &&
                      data.steps.fgts.status.trim() == 'Ressarcida') ||
                    (data.steps.contract.actived &&
                      data.steps.engineering.status.trim() == 'Válido' &&
                      data.steps.forms.situation.trim() == 'Recebidos' &&
                      !data.fgts)
                  "
                  >{{ data.steps.contract.note }}
                  {{ data.steps.contract.dueDate | formatDate }}</em
                >
              </small>
              <small
                class="d-flex align-items-center collapsed float-right text-muted"
              >
                <span
                  aria-controls="collapseSuma"
                  v-if="!showCollapseSuma"
                  @click="showCollapseSuma = !showCollapseSuma"
                >
                  Ver detalhes <i class="fa fa-chevron-down ml-2"></i>
                </span>
                <span
                  aria-controls="collapseSuma"
                  v-if="showCollapseSuma"
                  @click="showCollapseSuma = !showCollapseSuma"
                >
                  Ver detalhes <i class="fa fa-chevron-up ml-2"></i>
                </span>
              </small>
            </div>
          </b-row>
          <b-row>
            <b-col>
              <b-collapse
                class="py-3"
                id="collapseSuma"
                v-model="showCollapseSuma"
              >
                <b-row>
                  <b-col>
                    <h6>
                      <small class="text-muted"
                        >Valor de Financiamento Pretendido</small
                      >
                      <br />{{ data.intendedFinancingValue | currency }}
                      <small class="exp" style="font-size: small"
                        ><!--{{ listToshow == '' ? proposals.length : listToshow.length }}--></small
                      >
                    </h6>
                  </b-col>

                  <b-col>
                    <h6>
                      <small class="text-muted"
                        >Valor de Financiamento Aprovado</small
                      >
                      <br />{{ data.approvedFinancingAmount | currency }}
                      <small class="exp" style="font-size: small"
                        ><!--{{ listToshow == '' ? proposals.length : listToshow.length }}--></small
                      >
                    </h6>
                  </b-col>

                  <h6>
                    <!--<small class="text-muted">Ticket Médio:</small> <br> {{(soma)/(listToshow == '' ? proposals.length : listToshow.length) | currency}}-->
                  </h6>
                </b-row>

                <b-row>
                  <b-col>
                    <h6>
                      <small class="text-muted">Valor de Compra e venda</small>
                      <br />{{ data.propertyValue | currency }}
                      <small class="exp" style="font-size: small"
                        ><!--{{ listToshow == '' ? proposals.length : listToshow.length }}--></small
                      >
                    </h6>
                  </b-col>

                  <b-col>
                    <h6>
                      <small class="text-muted"
                        >Valor de avaliação (engenharia)</small
                      >
                      <br />{{ data.engineeringEvaluation | currency }}
                      <small class="exp" style="font-size: small"
                        ><!--{{ listToshow == '' ? proposals.length : listToshow.length }}--></small
                      >
                    </h6>
                  </b-col>

                  <h6>
                    <!--<small class="text-muted">Ticket Médio:</small> <br> {{(soma)/(listToshow == '' ? proposals.length : listToshow.length) | currency}}-->
                  </h6>
                </b-row>

                <b-row>
                  <b-col>
                    <h6>
                      <small class="text-muted">Valor de Compra e venda</small>
                      <br />{{ data.propertyValue | currency }}
                      <small class="exp" style="font-size: small"
                        ><!--{{ listToshow == '' ? proposals.length : listToshow.length }}--></small
                      >
                    </h6>
                  </b-col>

                  <b-col>
                    <h6>
                      <small class="text-muted"
                        >Valor de avaliação (engenharia)</small
                      >
                      <br />{{ data.engineeringEvaluation | currency }}
                      <small class="exp" style="font-size: small"
                        ><!--{{ listToshow == '' ? proposals.length : listToshow.length }}--></small
                      >
                    </h6>
                  </b-col>

                  <h6>
                    <!--<small class="text-muted">Ticket Médio:</small> <br> {{(soma)/(listToshow == '' ? proposals.length : listToshow.length) | currency}}-->
                  </h6>
                </b-row>
              </b-collapse>
            </b-col>
          </b-row>
          <b-row>
            <div class="col-md-12 mt-3">
              <ul class="timeline">
                <li class="text-left">
                  <!-- mb-5-->
                  <b-spinner
                    class="positionAlign"
                    type="grow"
                    :variant="
                      data.steps.riskAssessment.status == 'Aprovado' ||
                      data.steps.riskAssessment.status == 'Condicionado'
                        ? 'info'
                        : 'warning'
                    "
                    small
                    label="Loading..."
                    v-if="
                      data.steps.riskAssessment.actived &&
                      data.steps.riskAssessment.status != 'Aprovado' &&
                      data.steps.riskAssessment.actived &&
                      data.steps.riskAssessment.status != 'Condicionado' &&
                      data.steps.riskAssessment.actived &&
                      data.steps.riskAssessment.status != 'Reprovada'
                    "
                  ></b-spinner>
                  <!--:class="data.steps.riskAssessment.status == 'Reprovada' ? 'bg-danger' : 
                        data.steps.riskAssessment.status == 'Aprovado' || data.steps.riskAssessment.status == 'Condicionado' ? 'bg-primary' : 'bg-warning'"-->
                  <span
                    class="stepDone"
                    :style="
                      data.steps.riskAssessment.status == 'Aprovado' ||
                      data.steps.riskAssessment.status == 'Condicionado'
                        ? 'background: #22c0e8; border: 3px solid white;'
                        : data.steps.riskAssessment.status == 'Reprovada'
                        ? 'background: red; border: 3px solid white;'
                        : data.steps.riskAssessment.status == ''
                        ? ''
                        : 'background: orange; border: 3px solid white;'
                    "
                  >
                  </span>
                  <!--:class="data.steps.riskAssessment.status == 'Aprovado' || data.steps.riskAssessment.status == 'bg-danger' ? '' : 'stepDone'"-->
                  <span class="text-primary">Avaliação de risco</span>
                  <!--<span class="text-primary float-right">{{ data.steps.riskAssessment.dueDate | formatDate }}</span>-->
                  <!--<hr>-->
                  <div>
                    <b-row>
                      <b-col>
                        <span
                          v-if="
                            data.steps.riskAssessment.situation != 'Analisado'
                          "
                          class="text-secondary"
                          >{{ data.steps.riskAssessment.situation }}</span
                        >
                        <span v-else class="text-secondary">{{
                          data.steps.riskAssessment.status
                        }}</span>
                        <!--<span class="text-secondary float-right">{{ data.steps.riskAssessment.status }}</span>-->
                      </b-col>
                    </b-row>
                  </div>
                </li>
                <li class="text-left">
                  <!-- mb-5-->
                  <b-spinner
                    class="positionAlign"
                    type="grow"
                    :variant="
                      data.steps.engineering.situation != 'Laudo' ||
                      data.steps.engineering.status == 'Válido'
                        ? 'info'
                        : 'warning'
                    "
                    small
                    label="Loading..."
                    v-if="
                      data.steps.engineering.actived &&
                      data.steps.engineering.status != 'Válido' &&
                      data.steps.engineering.status != 'Inválido'
                    "
                  ></b-spinner>
                  <span
                    class="stepDone"
                    :style="
                      data.steps.engineering.status == 'Válido'
                        ? 'background: #22c0e8; border: 3px solid white;'
                        : data.steps.engineering.status == 'Inválido'
                        ? 'background: red; border: 3px solid white;'
                        : data.steps.engineering.status == ''
                        ? ''
                        : 'background: orange; border: 3px solid white;'
                    "
                  >
                  </span>
                  <span class="text-primary"
                    >Engenharia (Avaliação do Imóvel)</span
                  >
                  <span
                    v-if="data.steps.engineering.dueDate"
                    class="text-primary float-right"
                    ><small>{{
                      data.steps.engineering.dueDate | formatDate
                    }}</small></span
                  >
                  <span v-else class="text-primary float-right">-</span>
                  <!--<hr>-->
                  <div>
                    <b-row>
                      <b-col>
                        <span
                          v-if="data.steps.engineering.situation != 'Laudo'"
                          class="text-secondary"
                          >{{ data.steps.engineering.situation }}</span
                        >
                        <span v-else class="text-secondary">{{
                          data.steps.engineering.status
                        }}</span>
                        <!--<span class="text-secondary float-right">{{ data.steps.riskAssessment.status }}</span>-->
                      </b-col>
                    </b-row>
                  </div>
                </li>
                <li class="text-left">
                  <!-- mb-5-->
                  <b-spinner
                    class="positionAlign"
                    type="grow"
                    :variant="
                      data.steps.forms.situation != 'Recebidos' &&
                      data.steps.forms.status != 'Inconforme'
                        ? 'info'
                        : 'warning'
                    "
                    small
                    label="Loading..."
                    v-if="
                      (data.steps.forms.actived &&
                        data.steps.forms.situation != 'Recebidos') ||
                      (data.steps.forms.actived &&
                        data.steps.forms.status == 'Inconforme')
                    "
                  ></b-spinner>
                  <span
                    class="stepDone"
                    :style="
                      data.steps.forms.situation == 'Recebidos' &&
                      data.steps.forms.status != 'Inconforme'
                        ? 'background: #22c0e8; border: 3px solid white;'
                        : data.steps.forms.status == ''
                        ? ''
                        : 'background: orange; border: 3px solid white;'
                    "
                  >
                  </span>
                  <span class="text-primary">Formulários</span>
                  <span
                    v-if="data.steps.forms.dueDate"
                    class="text-primary float-right"
                    ><small>{{
                      data.steps.forms.dueDate | formatDate
                    }}</small></span
                  >
                  <span v-else class="text-primary float-right">-</span>
                  <!--<hr>-->
                  <div>
                    <b-row>
                      <b-col>
                        <span
                          v-if="
                            data.steps.forms.situation != 'Recebidos' ||
                            data.steps.forms.status != 'Inconforme'
                          "
                          class="text-secondary"
                          >{{ data.steps.forms.situation }}</span
                        >
                        <span v-else class="text-secondary"
                          >Formulários com pendência(s) a regularizar</span
                        >
                        <!--<span class="text-secondary float-right">{{ data.steps.riskAssessment.status }}</span>-->
                      </b-col>
                    </b-row>
                  </div>
                </li>
                <li class="text-left">
                  <!-- mb-5-->
                  <b-spinner
                    class="positionAlign"
                    type="grow"
                    :variant="
                      data.steps.fgts.status != 'Com erro' ? 'info' : 'warning'
                    "
                    small
                    label="Loading..."
                    v-if="
                      data.steps.fgts.actived &&
                      data.steps.fgts.status != 'Ressarcida'
                    "
                  ></b-spinner>
                  <span
                    class="stepDone"
                    :style="
                      !data.fgts
                        ? 'background: #22c0e8; border: 3px solid white;'
                        : data.steps.fgts.status == 'Ressarcida'
                        ? 'background: #22c0e8; border: 3px solid white;'
                        : data.steps.fgts.status ==
                          'Liberação de ressarcimento solicitada'
                        ? ''
                        : data.steps.fgts.status == ''
                        ? ''
                        : 'background: orange; border: 3px solid white;'
                    "
                  >
                  </span>
                  <span class="text-primary">FGTS</span>
                  <span
                    v-if="data.steps.fgts.dueDate"
                    class="text-primary float-right"
                    ><small>{{
                      data.steps.fgts.dueDate | formatDate
                    }}</small></span
                  >
                  <span v-else class="text-primary float-right">-</span>
                  <!--<hr>-->
                  <div>
                    <b-row>
                      <b-col>
                        <span v-if="!data.fgts" class="text-warning"
                          ><i class="fas fa-exclamation-triangle mr-2"></i
                          >Proposta sem utilização de FGTS</span
                        >
                        <span
                          v-else-if="data.steps.fgts.situation == 'Cadastrado'"
                          class="text-secondary"
                          >{{ data.steps.fgts.situation }}</span
                        >
                        <span
                          v-else-if="data.steps.fgts.situation != 'Cadastrado'"
                          class="text-secondary"
                          >{{ data.steps.fgts.status }}</span
                        >
                        <!--<span class="text-secondary float-right">{{ data.steps.riskAssessment.status }}</span>-->
                      </b-col>
                    </b-row>
                  </div>
                </li>
                <li class="text-left">
                  <!-- mb-5-->
                  <b-spinner
                    class="positionAlign"
                    type="grow"
                    :variant="
                      data.steps.contract.status != 'Com exigência'
                        ? 'info'
                        : 'warning'
                    "
                    small
                    label="Loading..."
                    v-if="
                      data.steps.contract.actived &&
                      data.steps.contract.status != 'Contratada' &&
                      data.steps.contract.actived &&
                      data.steps.contract.status != 'Evoluída'
                    "
                  ></b-spinner>
                  <span
                    class="stepDone"
                    :style="
                      data.steps.contract.status == 'Contratada' ||
                      data.steps.contract.status == 'Evoluída'
                        ? 'background: #22c0e8; border: 3px solid white;'
                        : data.steps.contract.status == 'Com exigência'
                        ? 'border: 3px solid orange;'
                        : data.steps.contract.status == ''
                        ? ''
                        : ''
                    "
                  >
                  </span>
                  <span class="text-primary">Escritura</span>
                  <span
                    v-if="data.steps.contract.dueDate"
                    class="text-primary float-right"
                    ><small>{{
                      data.steps.contract.dueDate | formatDate
                    }}</small></span
                  >
                  <span v-else class="text-primary float-right">-</span>
                  <div>
                    <b-row>
                      <b-col>
                        <span
                          v-if="
                            data.steps.contract.status != 'Contratada' &&
                            data.steps.contract.status != 'Evoluída'
                          "
                          class="text-secondary"
                          >{{ data.steps.contract.situation }}</span
                        >
                        <span v-else class="text-secondary">{{
                          data.steps.contract.status
                        }}</span>
                      </b-col>
                    </b-row>
                  </div>
                </li>
              </ul>
            </div>
          </b-row>
        </div>
      </b-sidebar>
    </div>
  </div>
</template>

<script>
var bootbox = require("bootbox");
import { mapActions, mapMutations, mapState } from "vuex";
//import TimeLine from "../../components/common/TimelineDetails";
var moment = require("moment");
moment.locale("pt");

export default {
  name: "ExpectedProposalsForUser",
  components: {},
  data() {
    return {
      payAttention: false,
      showCollapseSuma: false,
      alertMessage: [],
      contractAlertDiffInHr: null,
      contractUpdateDiff: null,
      engineeringAlertDiffInHr: null,
      formsAlertDiffInHr: null,
      fgtsAlertDiffInHr: null,
      engineeringForSnooze: false,
      engineeringForOk: false,
      formsForOk: false,
      formsForSnooze: false,
      contractForOk: false,
      contractForSnooze: false,
      fgtsForOk: false,
      fgtsForSnooze: false,
      moment: moment,
      showFgtsSubtask: false,
      showPropertyIQSubtask: false,
      showFormSubtask: false,
    };
  },
  props: ["data", "tabSelected"],
  //  components: { TimeLine },
  computed: {
    ...mapState(["user", "errorMessage", "dismissCountDown", "proposalToEdit"]),
    getDateCreated() {
      var createdDate = this.data.created.toDate();
      return moment(createdDate).locale("pt-BR").format("L [às] LTS");
    },
    getDateUpdated() {
      var updatedDate = this.data.updated.toDate();
      return moment(updatedDate).locale("pt-BR").format("L [às] LTS");
    },
    issueDateExpired() {
      if (this.data.issueDate) {
        const today = new Date();
        const issuedDate = moment(this.data.issueDate).toDate();
        const diff = today.getTime() - issuedDate.getTime();
        const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
        if (days > 30) {
          return "Vencido";
        } else {
          return "Válido";
        }
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapActions([
      "deleteProposal",
      "dismissed",
      "editProposal",
      "getProposalForEdit",
      "setProposalOpen",
    ]),
    definesLowerValueOfTheOperation(data) {
      if (data.approvedFinancingAmount === 0) {
        return data.intendedFinancingValue;
      } else if (
        data.intendedFinancingValue <= data.approvedFinancingAmount &&
        data.operationValue === 0
      ) {
        return data.intendedFinancingValue;
      } else if (
        data.approvedFinancingAmount <= data.intendedFinancingValue &&
        data.operationValue === 0
      ) {
        return data.approvedFinancingAmount;
      } else {
        return data.operationValue;
      }
    },
    definePayAttentionProposal2(data) {
      let currentDate = moment();
      let currentDateStart = moment().startOf("day");
      var today = new Date();
      var updatedDate = data.updated.toDate();
      var diff = today.getTime() - updatedDate.getTime();
      var days = Math.ceil(diff / (1000 * 60 * 60 * 24));
      // contract
      const contractDueDate = moment(`${data.steps.contract.dueDate}`);
      const contractDiff = moment.duration(currentDate.diff(contractDueDate));
      const contractDate = Math.ceil(contractDiff.asDays());
      const contractUpdateDate = moment(`${data.steps.contract.updatedAlert}`);
      const contractUpdateDiff = moment.duration(
        currentDate.diff(contractUpdateDate)
      );
      const contractAlertDiffInHr = contractUpdateDiff.asHours();
      const contractUpdateStartDate = moment(
        `${data.steps.contract.updatedAlert}`
      ).startOf("day");

      if (contractUpdateDiff.asDays()) {
        this.contractUpdateDays = contractUpdateDiff.asDays();
      } else {
        this.contractUpdateDays = contractDate;
      }

      // console.log(contractDate, 'contractDate22222', data.name, contractDueDate, contractUpdateDate, this.contractUpdateDays, contractUpdateDiff.asDays())

      if (
        contractAlertDiffInHr > 3 &&
        data.steps.contract.alertType === "snooze"
      ) {
        this.contractForSnooze = true;
      }
      if (
        currentDateStart.diff(contractUpdateStartDate, "days") >= 1 &&
        data.steps.contract.alertType === "ok"
      ) {
        this.contractForOk = true;
      }
      // engineering
      const engineeringDueDate = moment(`${data.steps.engineering.dueDate}`);
      const engineeringDiff = moment.duration(
        currentDate.diff(engineeringDueDate)
      );
      const engineeringDate = Math.ceil(engineeringDiff.asDays());
      const engineeringUpdateDate = moment(
        `${data.steps.engineering.updatedAlert}`
      );
      const engineeringUpdateStartDate = moment(
        `${data.steps.engineering.updatedAlert}`
      ).startOf("day");
      const engineeringUpdateDiff = moment.duration(
        currentDate.diff(engineeringUpdateDate)
      );
      const engineeringAlertDiffInHr = engineeringUpdateDiff.asHours();
      if (
        engineeringAlertDiffInHr > 3 &&
        data.steps.engineering.alertType === "snooze"
      ) {
        this.engineeringForSnooze = true;
      }
      if (
        currentDateStart.diff(engineeringUpdateStartDate, "days") >= 1 &&
        data.steps.engineering.alertType === "ok"
      ) {
        this.engineeringForOk = true;
      }
      // forms
      const formsUpdateDate = moment(`${data.steps.forms.updatedAlert}`);
      const formsUpdateStartDate = moment(
        `${data.steps.forms.updatedAlert}`
      ).startOf("day");
      const formsUpdateDiff = moment.duration(
        currentDate.diff(formsUpdateDate)
      );
      const formsDueDate = moment(`${data.steps.forms.dueDate}`);
      const formsDiff = moment.duration(currentDate.diff(formsDueDate));
      const formsDate = Math.ceil(formsDiff.asDays());
      const formsAlertDiffInHr = formsUpdateDiff.asHours();
      this.formsAlertDiffInHr = formsAlertDiffInHr;
      if (formsAlertDiffInHr > 3 && data.steps.forms.alertType === "snooze") {
        this.formsForSnooze = true;
      }
      if (
        currentDateStart.diff(formsUpdateStartDate, "days") >= 1 &&
        data.steps.forms.alertType === "ok"
      ) {
        this.formsForOk = true;
      }
      // fgts
      const fgtsDueDate = `${data.steps.fgts.dueDate}`;
      const fgtsDiff = moment.duration(currentDate.diff(fgtsDueDate));
      const fgtsDate = Math.ceil(fgtsDiff.asDays());
      const fgtsUpdateDate = moment(`${data.steps.fgts.updatedAlert}`);
      const fgtsUpdateStartDate = moment(
        `${data.steps.fgts.updatedAlert}`
      ).startOf("day");
      const fgtsUpdateDiff = moment.duration(currentDate.diff(fgtsUpdateDate));
      const fgtsAlertDiffInHr = fgtsUpdateDiff.asHours();
      if (fgtsAlertDiffInHr > 3 && data.steps.fgts.alertType === "snooze") {
        this.fgtsForSnooze = true;
      }
      if (
        currentDateStart.diff(fgtsUpdateStartDate, "days") >= 1 &&
        data.steps.fgts.alertType === "ok"
      ) {
        this.fgtsForOk = true;
      }
      //
      this.contractAlertDiffInHr = contractAlertDiffInHr;
      this.fgtsAlertDiffInHr = fgtsAlertDiffInHr;

      // Bloqueia a atenção para as propostas já EVOLUÍDAS.
      if (
        data.steps.contract.actived &&
        data.steps.contract.situation == "Emitida" &&
        data.steps.contract.status == "Agendada" &&
        contractDate >= 1 &&
        data.steps.contract.alertRule &&
        (this.contractForSnooze || this.contractForOk)
      ) {
        return true;
      } else if (
        data.steps.contract.actived &&
        data.steps.contract.situation == "Emitida" &&
        data.steps.contract.status == "Contratada" &&
        contractDate >= 1 &&
        data.steps.contract.alertRule &&
        (this.contractForSnooze || this.contractForOk)
      ) {
        return true;
      }
      // Chama a atenção para as propostas da fase de ESCRITURA que não estão na situação EVOUÍDA e que não houve atualiação em 2 dia.
      else if (
        data.steps.contract.actived &&
        data.steps.contract.situation == "Em análise de conformidade" &&
        data.steps.contract.status == "Enviando" &&
        this.contractUpdateDays >= 3 &&
        data.steps.contract.alertRule &&
        (this.contractForSnooze || this.contractForOk)
      ) {
        return true;
      } else if (
        data.steps.contract.actived &&
        data.steps.contract.situation == "Em análise de conformidade" &&
        data.steps.contract.status == "Enviado" &&
        contractDate >= 2 &&
        data.steps.contract.alertRule &&
        (this.contractForSnooze || this.contractForOk)
      ) {
        return true;
      } else if (
        data.steps.contract.actived &&
        data.steps.contract.situation == "Em análise de conformidade" &&
        data.steps.contract.status == "Conforme" &&
        contractDate >= 2 &&
        data.steps.contract.alertRule &&
        (this.contractForSnooze || this.contractForOk)
      ) {
        return true;
      } else if (
        data.steps.contract.actived &&
        data.steps.contract.situation == "Em análise de conformidade" &&
        data.steps.contract.status == "Com exigência" &&
        contractDate >= 2 &&
        // data.steps.contract.alertRule &&
        (this.contractForSnooze || this.contractForOk)
      ) {
        return true;
      } else if (
        data.steps.contract.actived &&
        data.steps.contract.situation == "Em análise de conformidade" &&
        data.steps.contract.status == "Reenviada" &&
        contractDate >= 1 &&
        // data.steps.contract.alertRule &&
        (this.contractForSnooze || this.contractForOk)
      ) {
        return true;
      }
      // Chama a atenção para as propostas da fase de ESCRITURA que não estão na situação EVOUÍDA e que não houve atualiação em 2 dia.

      // Chama a atenção para as propostas da fase de FGTS que não estão no status RESSARCIDA e que não houve atualiação em 1 dia.
      else if (
        data.steps.fgts.actived &&
        data.steps.fgts.situation == "Cadastrado" &&
        fgtsDate >= 2 &&
        // data.steps.fgts.alertRule &&
        (this.fgtsForSnooze || this.fgtsForOk)
      ) {
        return true;
      } else if (
        data.steps.fgts.actived &&
        data.steps.fgts.situation == "Solicitado" &&
        data.steps.fgts.status == "Liberação de ressarcimento solicitada em" &&
        fgtsDate >= 3 &&
        // data.steps.fgts.alertRule &&
        (this.fgtsForSnooze || this.fgtsForOk)
      ) {
        return true;
      } else if (
        data.steps.fgts.actived &&
        data.steps.fgts.situation == "Solicitado" &&
        data.steps.fgts.status == "Com erro" &&
        fgtsDate >= 2 &&
        // data.steps.fgts.alertRule &&
        (this.fgtsForSnooze || this.fgtsForOk)
      ) {
        return true;
      }
      // Chama a atenção para as propostas da fase de FORMULÁRIOS que estão na situação de ENVIADOS ou com o status INCONFORME e que não houve atualiação em 2 dia.
      else if (
        data.steps.forms.actived &&
        data.steps.forms.situation == "Emitidos" &&
        formsDate >= 1 &&
        // data.steps.forms.alertRule &&
        (this.formsForSnooze || this.formsForOk)
      ) {
        return true;
      } else if (
        data.steps.forms.actived &&
        data.steps.forms.situation == "Enviados" &&
        formsDate > 2 &&
        // data.steps.forms.alertRule &&
        (this.formsForSnooze || this.formsForOk)
      ) {
        return true;
      } else if (
        data.steps.forms.actived &&
        data.steps.forms.situation === "Recebidos" &&
        data.steps.forms.status === "Inconforme" &&
        formsDate >= 2 &&
        // data.steps.forms.alertRule &&
        (this.formsForSnooze || this.formsForOk)
      ) {
        return true;
      }
      // Chama a atenção para as propostas da fase de ENGENHARIA com STIUAÇÃO em BOLETO/CONVOCADA/EMITIDA que não houve atualiação nos respectivos prazos.
      else if (
        data.steps.engineering.actived &&
        data.steps.engineering.situation == "Boleto" &&
        engineeringDate >= 1 &&
        // data.steps.engineering.alertRule &&
        (this.engineeringForSnooze || this.engineeringForOk)
      ) {
        return true;
      } else if (
        data.steps.engineering.actived &&
        data.steps.engineering.situation == "Convocada" &&
        engineeringDate >= 1 &&
        // data.steps.engineering.alertRule &&
        (this.engineeringForSnooze || this.engineeringForOk)
      ) {
        return true;
      } else if (
        data.steps.engineering.actived &&
        data.steps.engineering.situation == "Emitida" &&
        engineeringDate >= 4 &&
        // data.steps.engineering.alertRule &&
        (this.engineeringForSnooze || this.engineeringForOk)
      ) {
        return true;
      } else {
        return false;
      }
    },
    handleAlert(data) {
      let currentDate = moment();
      const contractDueDate = moment(`${data.steps.contract.dueDate}`);
      const contractDiff = moment.duration(currentDate.diff(contractDueDate));
      const contractDate = Math.ceil(contractDiff.asDays());

      const engineeringDueDate = moment(`${data.steps.engineering.dueDate}`);
      const engineeringDiff = moment.duration(
        currentDate.diff(engineeringDueDate)
      );
      const engineeringDate = Math.ceil(engineeringDiff.asDays());

      const formsDueDate = moment(`${data.steps.forms.dueDate}`);
      const formsDiff = moment.duration(currentDate.diff(formsDueDate));
      const formsDate = Math.ceil(formsDiff.asDays());

      const fgtsDueDate = moment(`${data.steps.fgts.dueDate}`);
      const fgtsDiff = moment.duration(currentDate.diff(fgtsDueDate));
      const fgtsDate = Math.ceil(fgtsDiff.asDays());
      this.alertMessage = [];
      // Bloqueia a atenção para as propostas já EVOLUÍDAS.
      if (
        data.steps.contract.actived &&
        data.steps.contract.situation == "Emitida" &&
        data.steps.contract.status == "Agendada" &&
        contractDate >= 1 &&
        data.steps.contract.alertRule &&
        (this.contractForSnooze || this.contractForOk)
      ) {
        this.alertMessage.push("Verifique se houve contratação da proposta.");
      }
      if (
        data.steps.contract.actived &&
        data.steps.contract.situation == "Emitida" &&
        data.steps.contract.status == "Contratada" &&
        contractDate >= 1 &&
        data.steps.contract.alertRule &&
        (this.contractForSnooze || this.contractForOk)
      ) {
        this.alertMessage.push(
          "Verifique se houve a evolução da proposta no SIOPI."
        );
      }
      // Chama a atenção para as propostas da fase de ESCRITURA que não estão na situação EVOUÍDA e que não houve atualiação em 2 dia.
      if (
        data.steps.contract.actived &&
        data.steps.contract.situation == "Em análise de conformidade" &&
        data.steps.contract.status == "Enviando" &&
        this.contractUpdateDays >= 3 &&
        // data.steps.contract.alertRule &&
        (this.contractForSnooze || this.contractForOk)
      ) {
        this.alertMessage.push("Confira a pendência para enviar para análise.");
      }
      if (
        data.steps.contract.actived &&
        data.steps.contract.situation == "Em análise de conformidade" &&
        data.steps.contract.status == "Enviado" &&
        contractDate >= 2 &&
        // data.steps.contract.alertRule &&
        (this.contractForSnooze || this.contractForOk)
      ) {
        this.alertMessage.push(
          "Confira se já houve retorno da análise da proposta."
        );
      }
      if (
        data.steps.contract.actived &&
        data.steps.contract.situation == "Em análise de conformidade" &&
        data.steps.contract.status == "Conforme" &&
        contractDate >= 2 &&
        // data.steps.contract.alertRule &&
        (this.contractForSnooze || this.contractForOk)
      ) {
        this.alertMessage.push(
          "Verifique a data de agendamento da proposta para assinatura."
        );
      }
      if (
        data.steps.contract.actived &&
        data.steps.contract.situation == "Em análise de conformidade" &&
        data.steps.contract.status == "Com exigência" &&
        contractDate >= 2 &&
        // data.steps.contract.alertRule &&
        (this.contractForSnooze || this.contractForOk)
      ) {
        this.alertMessage.push(
          "Cumpra as exigências dessa proposta para reenviar para análise."
        );
      }
      if (
        data.steps.contract.actived &&
        data.steps.contract.situation == "Em análise de conformidade" &&
        data.steps.contract.status == "Reenviada" &&
        contractDate >= 1 &&
        // data.steps.contract.alertRule &&
        (this.contractForSnooze || this.contractForOk)
      ) {
        this.alertMessage.push(
          "Confira se já houve retorno da reanálise dessa proposta."
        );
      }
      // Chama a atenção para as propostas da fase de FGTS que não estão no status RESSARCIDA e que não houve atualiação em 1 dia.
      if (
        data.steps.fgts.actived &&
        data.steps.fgts.situation == "Cadastrado" &&
        fgtsDate >= 2 &&
        // data.steps.fgts.alertRule &&
        (this.fgtsForSnooze || this.fgtsForOk)
      ) {
        this.alertMessage.push(
          "Débito de FGTS cadastrado sem comando de débito."
        );
      }
      if (
        data.steps.fgts.actived &&
        data.steps.fgts.situation == "Solicitado" &&
        data.steps.fgts.status == "Liberação de ressarcimento solicitada em" &&
        fgtsDate >= 3 &&
        // data.steps.fgts.alertRule &&
        (this.fgtsForSnooze || this.fgtsForOk)
      ) {
        this.alertMessage.push("Confira o débito de FGTS se está OK.");
      }
      if (
        data.steps.fgts.actived &&
        data.steps.fgts.situation == "Solicitado" &&
        data.steps.fgts.status == "Com erro" &&
        fgtsDate >= 2 &&
        // data.steps.fgts.alertRule &&
        (this.fgtsForSnooze || this.fgtsForOk)
      ) {
        this.alertMessage.push("Débito de FGTS com erro e não houve o acerto.");
      }
      // Chama a atenção para as propostas da fase de FORMULÁRIOS que estão na situação de ENVIADOS ou com o status INCONFORME e que não houve atualiação em 2 dia.
      if (
        data.steps.forms.actived &&
        data.steps.forms.situation == "Emitidos" &&
        formsDate >= 1 &&
        // data.steps.forms.alertRule &&
        (this.formsForSnooze || this.formsForOk)
      ) {
        this.alertMessage.push("Formulários emitidos e não enviados.");
      }
      if (
        data.steps.forms.actived &&
        data.steps.forms.situation == "Enviados" &&
        formsDate > 2 &&
        // data.steps.forms.alertRule &&
        (this.formsForSnooze || this.formsForOk)
      ) {
        this.alertMessage.push("Formulários enviados e não recebidos.");
      }
      if (
        data.steps.forms.actived &&
        data.steps.forms.situation === "Recebidos" &&
        data.steps.forms.status === "Inconforme" &&
        formsDate >= 2 &&
        data.steps.forms.alertRule &&
        (this.formsForSnooze || this.formsForOk)
      ) {
        this.alertMessage.push(
          "Formulários estão de desacordo e não foram reenviados."
        );
      }
      // Chama a atenção para as propostas da fase de ENGENHARIA com STIUAÇÃO em BOLETO/CONVOCADA/EMITIDA que não houve atualiação nos respectivos prazos.
      if (
        data.steps.engineering.actived &&
        data.steps.engineering.situation == "Boleto" &&
        engineeringDate >= 1 &&
        // data.steps.engineering.alertRule &&
        (this.engineeringForSnooze || this.engineeringForOk)
      ) {
        this.alertMessage.push("Verifique opagamento do boleto");
      }
      if (
        data.steps.engineering.actived &&
        data.steps.engineering.situation == "Convocada" &&
        engineeringDate >= 1 &&
        // data.steps.engineering.alertRule &&
        (this.engineeringForSnooze || this.engineeringForOk)
      ) {
        this.alertMessage.push("Verifique se aengenharia foi emitida.");
      }
      if (
        data.steps.engineering.actived &&
        data.steps.engineering.situation == "Emitida" &&
        engineeringDate >= 4 &&
        // data.steps.engineering.alertRule &&
        (this.engineeringForSnooze || this.engineeringForOk)
      ) {
        this.alertMessage.push(
          "Enviar e-mail para a credenciada.<br>Obs.: Faltam 3 dias para a conclusão da O.S.."
        );
      }

      // Chama a atenção para as propostas da fase de AVALIAÇÃO DE RISCO
      for (let index = 0; index < this.alertMessage.length; index++) {
        bootbox.dialog({
          title: "Notification",
          message: `<p>${this.alertMessage[index]}</p>`,
          size: "large",
          centerVertical: true,
          buttons: {
            cancel: {
              label: "Cancel",
              className: "btn-danger",
              callback: function () {
                console.log("Cancel clicked");
              },
            },
            snooze: {
              label: "Snooze",
              className: "btn-warning",
              callback: async () => {
                if (
                  this.alertMessage[index] ===
                    "Verifique se houve contratação da proposta." ||
                  this.alertMessage[index] ===
                    "Verifique se houve a evolução da proposta no SIOPI." ||
                  this.alertMessage[index] ===
                    "Confira a pendência para enviar para análise." ||
                  this.alertMessage[index] ===
                    "Confira se já houve retorno da análise da proposta." ||
                  this.alertMessage[index] ===
                    "Verifique a data de agendamento da proposta para assinatura." ||
                  this.alertMessage[index] ===
                    "Cumpra as exigências dessa proposta para reenviar para análise." ||
                  this.alertMessage[index] ===
                    "Confira se já houve retorno da reanálise dessa proposta."
                ) {
                  // data.steps.contract.alertRule = false;
                  data.steps.contract.updatedAlert = new Date().toString();
                  data.steps.contract.alertType = "snooze";
                  this.contractForSnooze = false;
                  this.contractForOk = false;
                } else if (
                  this.alertMessage[index] ===
                    "Débito de FGTS cadastrado sem comando de débito." ||
                  this.alertMessage[index] ===
                    "Confira o débito de FGTS se está OK." ||
                  this.alertMessage[index] ===
                    "Débito de FGTS com erro e não houve o acerto."
                ) {
                  // data.steps.fgts.alertRule = false;
                  data.steps.fgts.updatedAlert = new Date().toString();
                  data.steps.fgts.alertType = "snooze";
                  this.fgtsForSnooze = false;
                  this.fgtsForOk = false;
                } else if (
                  this.alertMessage[index] ===
                    "Formulários emitidos e não enviados." ||
                  this.alertMessage[index] ===
                    "Formulários enviados e não recebidos." ||
                  this.alertMessage[index] ===
                    "Formulários estão de desacordo e não foram reenviados."
                ) {
                  // data.steps.forms.alertRule = false;
                  data.steps.forms.updatedAlert = new Date().toString();
                  data.steps.forms.alertType = "snooze";
                  this.formsForSnooze = false;
                  this.formsForOk = false;
                } else if (
                  this.alertMessage[index] ===
                    "Verifique opagamento do boleto" ||
                  this.alertMessage[index] ===
                    "Verifique se aengenharia foi emitida." ||
                  this.alertMessage[index] ===
                    "Enviar e-mail para a credenciada.<br>Obs.: Faltam 3 dias para a conclusão da O.S.."
                ) {
                  // data.steps.engineering.alertRule = false;
                  data.steps.engineering.updatedAlert = new Date().toString();
                  data.steps.engineering.alertType = "snooze";
                  this.engineeringForSnooze = false;
                  this.engineeringForOk = false;
                }
                data.alert = true;
                this.$forceUpdate();
                await this.getProposalForEdit(data.id);
                await this.editProposal(data);
                this.definePayAttentionProposal2(data);
              },
            },
            ok: {
              label: "OK",
              className: "btn-success",
              callback: async () => {
                if (
                  this.alertMessage[index] ===
                    "Verifique se houve contratação da proposta." ||
                  this.alertMessage[index] ===
                    "Verifique se houve a evolução da proposta no SIOPI." ||
                  this.alertMessage[index] ===
                    "Confira a pendência para enviar para análise." ||
                  this.alertMessage[index] ===
                    "Confira se já houve retorno da análise da proposta." ||
                  this.alertMessage[index] ===
                    "Verifique a data de agendamento da proposta para assinatura." ||
                  this.alertMessage[index] ===
                    "Cumpra as exigências dessa proposta para reenviar para análise." ||
                  this.alertMessage[index] ===
                    "Confira se já houve retorno da reanálise dessa proposta."
                ) {
                  // data.steps.contract.alertRule = false;
                  data.steps.contract.updatedAlert = new Date().toString();
                  data.steps.contract.alertType = "ok";
                  this.contractForSnooze = false;
                  this.contractForOk = false;
                } else if (
                  this.alertMessage[index] ===
                    "Débito de FGTS cadastrado sem comando de débito." ||
                  this.alertMessage[index] ===
                    "Confira o débito de FGTS se está OK." ||
                  this.alertMessage[index] ===
                    "Débito de FGTS com erro e não houve o acerto."
                ) {
                  // data.steps.fgts.alertRule = false;
                  data.steps.fgts.updatedAlert = new Date().toString();
                  data.steps.fgts.alertType = "ok";
                  this.fgtsForSnooze = false;
                  this.fgtsForOk = false;
                } else if (
                  this.alertMessage[index] ===
                    "Formulários emitidos e não enviados." ||
                  this.alertMessage[index] ===
                    "Formulários enviados e não recebidos." ||
                  this.alertMessage[index] ===
                    "Formulários estão de desacordo e não foram reenviados."
                ) {
                  // data.steps.forms.alertRule = false;
                  data.steps.forms.updatedAlert = new Date().toString();
                  data.steps.forms.alertType = "ok";
                  this.formsForSnooze = false;
                  this.formsForOk = false;
                } else if (
                  this.alertMessage[index] ===
                    "Verifique opagamento do boleto" ||
                  this.alertMessage[index] ===
                    "Verifique se aengenharia foi emitida." ||
                  this.alertMessage[index] ===
                    "Enviar e-mail para a credenciada.<br>Obs.: Faltam 3 dias para a conclusão da O.S.."
                ) {
                  // data.steps.engineering.alertRule = false;
                  data.steps.engineering.updatedAlert = new Date().toString();
                  data.steps.engineering.alertType = "ok";
                  this.engineeringForSnooze = false;
                  this.engineeringForOk = false;
                }
                data.alert = true;
                this.$forceUpdate();
                await this.getProposalForEdit(data.id);
                await this.editProposal(data);
                this.definePayAttentionProposal2(data);
              },
            },
          },
        });
      }
    },
    penultimateTitle(data) {
      let date = this.$options.filters.formatDate(data.dueDate);
      return data.note + " " + date;
    },

    async gotoEditProposal(id) {
      await this.getProposalForEdit(id);

      if (!this.proposalToEdit.isOpen) {
        await this.setProposalOpen({ id, val: true });
        this.$router.push({ name: "editProposal", params: { id: id } });
      } else {
        this.$store.commit("setErrorMessage", {
          color: "danger",
          text: "Ops... Proposal already open!",
        });
      }
    },
  },
  filters: {
    changeDateFilter: function (value) {
      if (Date.now() > "7") {
        return moment(value).fromNow();
      } else {
        return moment(value).calendar(null, {
          sameDay: "[Hoje]",
          nextDay: "[Amanhã]",
          nextWeek: "dddd",
          lastDay: "[Ontem]",
          lastWeek: "[Última] dddd",
          sameElse: "DD/MMM",
        });
      }
    },
    formatDate: function (value) {
      return moment(value).format("L");
    },
    uppercase: function (v) {
      return v.toUpperCase();
    },
  },
  async mounted() {
    //  await this.definePayAttentionProposal();
    // console.log(this.data, "0000000");
  },
};
</script>
<style scoped>
/* Proposal card styles */
.card {
  border: 1px solid rgba(0, 123, 255, 0.12);
}
.card-body {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 0.8rem;
}
.card-title {
  margin-top: 0.1rem;
  margin-bottom: 0.2rem;
  font-size: 0.9rem;
}
.card-footer {
  min-height: 45px;
}
.card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
.card:hover .hideDetails {
  display: none;
}
.card .showDetails {
  display: none;
}
.card:hover .showDetails {
  display: block;
}
a:link {
  text-decoration: none;
}

/* TIMELINE STYLE */
.themeColor {
  color: #007bff;
}
.pointer {
  cursor: pointer;
}
ul.timeline {
  list-style-type: none;
  position: relative;
}
ul.timeline:before {
  content: " ";
  background: #d4d9df;
  display: inline-block;
  position: absolute;
  left: 9px;
  width: 2px;
  height: 100%;
  z-index: 400;
  margin-top: 2px;
}
ul.timeline > li {
  margin: 30px 0;
  padding-left: 0px;
}
ul.timeline > li:before {
  content: " ";
  background: white;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 3px solid #22c0e8;
  left: 1px;
  width: 19px;
  height: 19px;
  z-index: 400;
  margin-top: 2px;
}
span.spinner-grow.positionAlign {
  content: " ";
  display: inline-block;
  position: absolute;
  /*background-color: #22c0e8;*/
  left: 1px;
  width: 19px;
  height: 19px;
  z-index: 999;
  margin-top: 2px;
}
span.stepDone {
  content: " ";
  /*background: #22c0e8;*/
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  /*border: 3px solid white;*/
  left: 1px;
  /*top: -1px*/
  width: 19px;
  height: 19px;
  z-index: 400;
  margin-top: 2px;
}
.list {
  position: relative;
}
.expanded-row {
  position: absolute;
  z-index: 999;
  background: whitesmoke;
  box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%);
  border: none;
  bottom: 50px;
}
.dot {
  width: 12px;
  height: 12px;
  border-radius: 10px;
}

.proposal-penultimate,
.proposal-title {
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
